import { render, staticRenderFns } from "./Wxts.vue?vue&type=template&id=fd8f7e58&scoped=true&"
import script from "./Wxts.vue?vue&type=script&lang=js&"
export * from "./Wxts.vue?vue&type=script&lang=js&"
import style0 from "./Wxts.vue?vue&type=style&index=0&id=fd8f7e58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8f7e58",
  null
  
)

export default component.exports